module.exports = __webpack_public_path__ + "img/content1.09a07e15.png";